module.exports = __webpack_public_path__ + "static/media/arrow_right.8957ba2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/arrow_right.svg
// module id = 526
// module chunks = 0